import { api, apitest } from '../api.request';

//年度成衣入库/出库走势
const get1 = function(o) {
        return api.get("/warehouse/get1", o)
    }
    //出库复核排行榜
const get2 = function(o) {
        return api.get("/warehouse/get2", o)
    }
    //出库拣货排行榜
const get3 = function(o) {
        return api.get("/warehouse/get3", o)
    }
    //入库TOP50
const get4 = function(o) {
        return api.get("/warehouse/get4", o)
    }
    //出库TOP50
const get5 = function(o) {
        return api.get("/warehouse/get5", o)
    }
    //仓储数据概览
const get6 = function(o) {
    return api.get("/warehouse/get6", o)
}

//出库复核和出库炼货排行
const getCheckAndPickedResponse = function(o) {
        return apitest.get("/warehouse/checkAndPickedResponse", o)
    }
    //入库TOP50
const getInTopResponse = function(o) {
        return apitest.get("/warehouse/inTopResponse", o)
    }
    //出库TOP50
const getOutTopResponse = function(o) {
        return apitest.get("/warehouse/outTopResponse", o)
    }
    //年度成衣趋势
const getStockTrendResponse = function(o) {
        return apitest.get("/warehouse/stockTrendResponse", o)
    }
    //仓库数据概览
const getWarehouseOverview = function(o) {
    return apitest.get("/warehouse/warehouseOverview", o)
}



export default {
    get1,
    get2,
    get3,
    get4,
    get5,
    get6,
    getCheckAndPickedResponse,
    getInTopResponse,
    getOutTopResponse,
    getStockTrendResponse,
    getWarehouseOverview
}